module.exports = __webpack_public_path__ + "static/img/yahong.57b3b74.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/yahong.png
// module id = iZ9U
// module chunks = 1